import React, {
  useEffect,
  useState
} from "react";

import axios from "axios";

function VerifyEmail(props) {

  const [message, setMessage] =
    useState(
      "Verifying email..."
    );

  useEffect(() => {

    const params =
      new URLSearchParams(
        window.location.search
      );

    const token =
      params.get("token");

    const userId =
      params.get("id");

    if (
      !token ||
      !userId
    ) {

      setMessage(
        "Invalid verification link"
      );

      return;
    }

    axios.post(
      "/verify-email",
      {
        token,
        userId
      },
      {
        withCredentials: true
      }
    )
    .then(() => {

      setMessage(
        "Email verified successfully"
      );

      setTimeout(() => {

        props.history.push(
          "/"
        );

      }, 2000);

    })
    .catch((err) => {

      setMessage(

        err?.response?.data?.message ||

        "Verification failed"
      );

    });

  }, [props.history]);

  return (
    <div>
      {message}
    </div>
  );
}

export default VerifyEmail;